import TopBar from "../../components/TopBar";
import Featured from "./featured";
import CovidUpdate from "./covidUpdate";
import HomeTownFitness from "./homeTownFitness";
import ReactGA from "react-ga";
import "./index.scss";

const Updates = () => {
  ReactGA.pageview(window.location.pathname + window.location.search);
  return (
    <div className="updates-page">
      <TopBar heading="The latest updates" />
      <HomeTownFitness />
      <CovidUpdate />
      <Featured />
    </div>
  );
};
export default Updates;
